import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { id: 'ALA', name: i18n.t('tipos.provincias.ala') },
    { id: 'ALB', name: i18n.t('tipos.provincias.alb') },
    { id: 'ALI', name: i18n.t('tipos.provincias.ali') },
    { id: 'ALM', name: i18n.t('tipos.provincias.alm') },
    { id: 'AST', name: i18n.t('tipos.provincias.ast') },
    { id: 'AVI', name: i18n.t('tipos.provincias.avi') },
    { id: 'BAD', name: i18n.t('tipos.provincias.bad') },
    { id: 'BAL', name: i18n.t('tipos.provincias.bal') },
    { id: 'BAR', name: i18n.t('tipos.provincias.bar') },
    { id: 'BUR', name: i18n.t('tipos.provincias.bur') },
    { id: 'CAC', name: i18n.t('tipos.provincias.cac') },
    { id: 'CAD', name: i18n.t('tipos.provincias.cad') },
    { id: 'CANT', name: i18n.t('tipos.provincias.cant') },
    { id: 'CAS', name: i18n.t('tipos.provincias.cas') },
    { id: 'CEU', name: i18n.t('tipos.provincias.ceu') },
    { id: 'CRE', name: i18n.t('tipos.provincias.cre') },
    { id: 'CORD', name: i18n.t('tipos.provincias.cord') },
    { id: 'CUE', name: i18n.t('tipos.provincias.cue') },
    { id: 'GIR', name: i18n.t('tipos.provincias.gir') },
    { id: 'GRA', name: i18n.t('tipos.provincias.gra') },
    { id: 'GUA', name: i18n.t('tipos.provincias.gua') },
    { id: 'GUI', name: i18n.t('tipos.provincias.gui') },
    { id: 'HUEL', name: i18n.t('tipos.provincias.huel') },
    { id: 'HUES', name: i18n.t('tipos.provincias.hues') },
    { id: 'JAE', name: i18n.t('tipos.provincias.jae') },
    { id: 'CORU', name: i18n.t('tipos.provincias.coru') },
    { id: 'RIO', name: i18n.t('tipos.provincias.rio') },
    { id: 'PALM', name: i18n.t('tipos.provincias.palm') },
    { id: 'LEO', name: i18n.t('tipos.provincias.leo') },
    { id: 'LLE', name: i18n.t('tipos.provincias.lle') },
    { id: 'LUG', name: i18n.t('tipos.provincias.lug') },
    { id: 'MAD', name: i18n.t('tipos.provincias.mad') },
    { id: 'MAL', name: i18n.t('tipos.provincias.mal') },
    { id: 'MEL', name: i18n.t('tipos.provincias.mel') },
    { id: 'MUR', name: i18n.t('tipos.provincias.mur') },
    { id: 'NAV', name: i18n.t('tipos.provincias.nav') },
    { id: 'OUR', name: i18n.t('tipos.provincias.our') },
    { id: 'PALE', name: i18n.t('tipos.provincias.pale') },
    { id: 'PON', name: i18n.t('tipos.provincias.pon') },
    { id: 'SAL', name: i18n.t('tipos.provincias.sal') },
    { id: 'SCT', name: i18n.t('tipos.provincias.sct') },
    { id: 'SEG', name: i18n.t('tipos.provincias.seg') },
    { id: 'SEV', name: i18n.t('tipos.provincias.sev') },
    { id: 'SOR', name: i18n.t('tipos.provincias.sor') },
    { id: 'TAR', name: i18n.t('tipos.provincias.tar') },
    { id: 'TER', name: i18n.t('tipos.provincias.ter') },
    { id: 'TOL', name: i18n.t('tipos.provincias.tol') },
    { id: 'VALE', name: i18n.t('tipos.provincias.vale') },
    { id: 'VALL', name: i18n.t('tipos.provincias.vall') },
    { id: 'VIZ', name: i18n.t('tipos.provincias.viz') },
    { id: 'ZAM', name: i18n.t('tipos.provincias.zam') },
    { id: 'ZAR', name: i18n.t('tipos.provincias.zar') },
  ]
}

export function PROVINCIAS (state) {
  return configHelper.getConfig(state, 'PROVINCIAS', GenerateConfig)
}
